/**
 * DynamicLatestNews image sizing: Contentful thumbnails are often much wider than
 * the portrait panel. The component requests a viewport-wide candidate to retain
 * crop detail while avoiding the former 200vw mobile over-fetch.
 */
export const DEFAULT_SLIDE_INTERVAL = 7000;
export const EXIT_ANIMATION_DURATION = 600;
export const WHEEL_IMAGE_SRC = '/images/gallet/vector-wheel.svg';
